var map = {
	"./clover.webp": 4428,
	"./discord.webp": 7633,
	"./press.webp": 1408,
	"./steam.webp": 9879,
	"./subscribe.webp": 2998,
	"./support.webp": 5539,
	"./traits.webp": 5928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9018;